import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MockupPreviewComponent } from '../mockup-preview/mockup-preview.component';
import { PhotosService } from '../services/photos.service';

@Component({
    selector: 'app-website-ui',
    templateUrl: './website-ui.component.html',
    styleUrls: ['./website-ui.component.css']
})
export class WebsiteUiComponent implements OnInit {

    websiteUi = [];
    appUi = [];
    etsyBanner = [];

    constructor(private photos: PhotosService, public dialog: MatDialog) { }

    ngOnInit() {
        this.websiteUi = this.photos.websiteUi;
        this.appUi = this.photos.appUi;
        this.etsyBanner = this.photos.etsyBanners;
    }

    openDialog(url: string): void {
        if (screen.width > 600) {
            this.dialog.open(MockupPreviewComponent, {
                maxHeight: '90%',
                width: '1000px',
                data: {url: url}
            });
        }
    }

}
